// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__UIhQA","content":"LoadingAlert_content__3kc9i"};